// extracted by mini-css-extract-plugin
export default {"container":"EmployeeHome-module__container--foSne"};